import React, { useMemo, useState } from 'react';
import { Modal } from '@components/v2/Modal';
import { Button } from '@ui';
import { FireIcon } from '@icons/FireIcon';
import { translate } from '@utils/i18n';
import Lottie from 'lottie-react';
import './styles.scss';
import useGetLastIaRun from '@features/IaResultsBanner/hooks/useGetLastIaRun';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import assistant from './animations/assistant.json';
const namespace = 'features.inspection_assistant_modal';
function InspectionAssistantModalContent() {
    var _a;
    const dismissKey = 'inspection-assistant-modal-dismissed';
    const [isIAModalOpen, setIsIAModalOpen] = useState(() => {
        return localStorage.getItem(dismissKey) !== 'true';
    });
    const { data: lastRunData, isLoading, isError } = useGetLastIaRun();
    if (isLoading || isError) {
        return null;
    }
    if (!(lastRunData === null || lastRunData === void 0 ? void 0 : lastRunData.iimRun) ||
        !isIAModalOpen ||
        !(lastRunData === null || lastRunData === void 0 ? void 0 : lastRunData.inspectionAssistantTeaserEnabled) ||
        (lastRunData === null || lastRunData === void 0 ? void 0 : lastRunData.isInspectpointUser) ||
        (!(lastRunData === null || lastRunData === void 0 ? void 0 : lastRunData.isInspectpointUser) && !((_a = lastRunData === null || lastRunData === void 0 ? void 0 : lastRunData.iimRun) === null || _a === void 0 ? void 0 : _a.published))) {
        return null;
    }
    const handleModalClose = () => {
        localStorage.setItem(dismissKey, 'true');
        setIsIAModalOpen(false);
    };
    const handleClick = () => {
        window.location.href = '/inspection_assistant_review';
    };
    const footer = (React.createElement("div", { className: "ia-modal__footer" },
        React.createElement(Button, { variant: "default", onClick: handleModalClose }, translate('close', { namespace: 'features.commons' })),
        React.createElement(Button, { variant: "primary", onClick: handleClick }, translate('button_title', { namespace }))));
    return (React.createElement(Modal, { title: translate('modal_title', { namespace }), isOpen: isIAModalOpen, onClose: handleModalClose, width: "920px", footer: footer, className: "ia-modal" },
        React.createElement("div", { className: "ia-modal__content" },
            React.createElement("div", { className: "ia-modal__sidebar" },
                React.createElement("div", { className: "ia-modal__icon" },
                    React.createElement(FireIcon, { width: 38, height: 48 })),
                React.createElement("h3", { className: "ia-modal__title" }, translate('title', { namespace })),
                React.createElement("p", { className: "ia-modal__description" }, translate('description', { namespace }))),
            React.createElement("div", { className: "ia-modal__main" },
                React.createElement("div", { className: "ia-modal__main__header" },
                    React.createElement("p", { className: "ia-modal__main__title" }, translate('main_title', { namespace })),
                    React.createElement("p", { className: "ia-modal__main__description" }, translate('main_description', { namespace }))),
                React.createElement("div", { className: "ia-modal__animation-wrapper" },
                    React.createElement("div", { className: "ia-modal__animation" },
                        React.createElement("div", { style: { height: `297px` } },
                            React.createElement(Lottie, { animationData: assistant, loop: true, autoplay: true }))))))));
}
function InspectionAssistantModal() {
    const queryClient = useMemo(() => new QueryClient(), []);
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(InspectionAssistantModalContent, null)));
}
export default InspectionAssistantModal;
